var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-margin-top-50", attrs: { id: "fuelResources" } },
    [
      _vm.loaders.fuelResources
        ? _c(
            "div",
            { staticClass: "loading-indicator" },
            [_c("MoonLoader", { attrs: { size: "75px", color: "#ffffff" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "tab-content" }, [_c("MemberDocuments")], 1)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid" }, [
      _c(
        "div",
        {
          staticClass:
            "grid__col--12 library__title meeting-agenda__title h-center-align"
        },
        [_vm._v("Welcome to Fuel Resources")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid" }, [
      _c("div", { staticClass: "grid__col--1" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid__col--10 library__subtitle meeting-agenda__subtitle h-center-align"
        },
        [
          _vm._v(
            "Learn more about Fuel's services, download documents and more with our resource page. Our guides will inform you of the many ways we support your practice. From professional development to human resources and everything in between, read more about our areas of expertise for practices of all sizes. Click on any of the tiles to download."
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid__col--1" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }